export default {
  totalMarketValue: 'Total market value',
  walletActions: 'Wallet actions',
  claim: 'Claim',
  swap: 'Swap',
  send: 'Send',
  receive: 'Receive',
  onChainAssets: 'On-chain assets',
  updateAssets: 'Refresh assets',
  selectAssetAccount: 'Select asset account',
  currentViewing: 'Viewing: {{source}}',
  inGameAssets: 'In-game assets',
  updateBalance: 'Refresh balances',
  priceLoading: 'Updating prices…',
  priceUnavailable: 'Prices temporarily unavailable',
  priceUpdatedAt: 'Prices updated at {{time}}',
  priceNotAvailable: 'No price available',
} as const;

